/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_Checkin_Note_MildInputs */

const en_us2_today_checkin_note_mild = /** @type {(inputs: Today_Checkin_Note_MildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mild soreness is normal after training and does not stop today's workout.`)
};

const pt_br2_today_checkin_note_mild = /** @type {(inputs: Today_Checkin_Note_MildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dor leve é normal depois de treinar e não impede o treino de hoje.`)
};

const es_419_today_checkin_note_mild = /** @type {(inputs: Today_Checkin_Note_MildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un dolor leve es normal después de entrenar y no impide el entrenamiento de hoy.`)
};

const pt_pt2_today_checkin_note_mild = /** @type {(inputs: Today_Checkin_Note_MildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma dor ligeira é normal depois de treinar e não impede o treino de hoje.`)
};

const fr_fr2_today_checkin_note_mild = /** @type {(inputs: Today_Checkin_Note_MildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des courbatures légères sont normales après l'entraînement et n'empêchent pas la séance du jour.`)
};

const de_de2_today_checkin_note_mild = /** @type {(inputs: Today_Checkin_Note_MildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leichter Muskelkater ist nach dem Training normal und hält dich heute nicht vom Training ab.`)
};

const it_it2_today_checkin_note_mild = /** @type {(inputs: Today_Checkin_Note_MildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un dolore lieve è normale dopo l'allenamento e non ti impedisce di allenarti oggi.`)
};

/**
* | output |
* | --- |
* | "Mild soreness is normal after training and does not stop today's workout." |
*
* @param {Today_Checkin_Note_MildInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_checkin_note_mild = /** @type {((inputs?: Today_Checkin_Note_MildInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Checkin_Note_MildInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_checkin_note_mild(inputs)
	if (locale === "es-419") return es_419_today_checkin_note_mild(inputs)
	if (locale === "pt-PT") return pt_pt2_today_checkin_note_mild(inputs)
	if (locale === "fr-FR") return fr_fr2_today_checkin_note_mild(inputs)
	if (locale === "de-DE") return de_de2_today_checkin_note_mild(inputs)
	if (locale === "it-IT") return it_it2_today_checkin_note_mild(inputs)
	return en_us2_today_checkin_note_mild(inputs)
});
export { today_checkin_note_mild as "today.checkin_note_mild" }